var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVentilation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_254)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 50,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.3292 57.2888L81.0393 56.4094L75.5089 55.0496C75.543 54.5569 75.5585 54.0625 75.5585 53.5633C75.5585 47.2323 72.7888 41.1921 67.9602 36.9909L65.707 39.4868C69.8095 43.0555 72.1614 48.1864 72.1614 53.5633C72.1614 53.7844 72.1583 54.0047 72.149 54.2236L68.5581 53.3408C68.5072 49.8799 67.2527 46.519 65.0096 43.8505L62.3891 45.9742C63.9472 47.8262 64.895 50.1098 65.1149 52.4945L61.455 51.5952C61.0598 49.9564 60.1797 48.4988 58.9725 47.377L64.537 28.3178L63.9078 27.6318C61.2103 24.6887 57.2379 23 53.0106 23C48.7834 23 44.8124 24.6887 42.1148 27.6318L41.4852 28.3178L43.0538 33.692C41.8228 34.289 40.6404 35.0006 39.5196 35.8243C35.7317 38.6049 32.8758 42.5676 31.4775 46.9804L34.7215 47.9709C36.2649 43.0967 39.6541 39.2088 44.0039 36.9461L45.0296 40.4617C43.6933 41.2468 42.4706 42.2304 41.413 43.3926L43.9459 45.6149C44.5663 44.9332 45.2597 44.3297 46.008 43.8136L47.0488 47.3783C45.8483 48.4944 44.9708 49.9429 44.5734 51.5717L40.9099 52.4624C41.0356 51.0851 41.4015 49.7574 42.0029 48.501L38.927 47.0838C37.992 49.0401 37.4995 51.1303 37.4632 53.2996L24.9753 56.3347L24.6828 57.2132C23.4283 60.9764 23.9177 65.1981 26.0249 68.7967C28.1321 72.3944 31.6018 74.9338 35.545 75.7632L36.4654 75.9566L40.4347 71.9378C44.1318 74.379 48.5037 75.6998 53.0106 75.6998C54.5665 75.6998 56.1201 75.5443 57.6295 75.2354L56.9366 71.97C55.6546 72.2324 54.3346 72.3645 53.0106 72.3645C49.3078 72.3645 45.8142 71.3152 42.8521 69.4883L45.4226 66.8855C47.6683 68.1241 50.2569 68.8301 53.0106 68.8301V65.4948C51.1831 65.4948 49.4494 65.0968 47.8935 64.383L50.5185 61.7237C51.3074 61.957 52.1442 62.0826 53.0106 62.0826C53.8691 62.0826 54.6979 61.9605 55.4816 61.7302L69.4948 76L70.4152 75.8088C74.3606 74.9908 77.8383 72.46 79.9548 68.8679C82.0722 65.2758 82.5726 61.0555 81.3292 57.2888ZM58.5867 60.0858C60.112 58.8276 61.1921 57.0641 61.5554 55.0582L78.341 59.1843C78.9534 61.8258 78.487 64.6989 77.0148 67.1979C75.5417 69.6964 73.2384 71.5251 70.5998 72.3201L58.5867 60.0858ZM45.2823 29.2219C47.3045 27.3785 50.0711 26.3353 53.0106 26.3353C55.9515 26.3353 58.7181 27.3785 60.739 29.2219L55.9719 45.554C55.0479 45.2225 54.0501 45.0422 53.0106 45.0422C51.9712 45.0422 50.9734 45.2225 50.0494 45.554L45.2823 29.2219ZM35.3706 72.2732C32.7342 71.4716 30.4354 69.6361 28.9702 67.1336C27.5051 64.6311 27.0453 61.7572 27.6657 59.1174L44.4637 55.0352C44.8212 57.0428 45.8961 58.8098 47.4192 60.0715L35.3706 72.2732ZM47.7302 53.5633C47.7302 50.7037 50.0994 48.3776 53.0106 48.3776C55.9232 48.3776 58.2919 50.7037 58.2919 53.5633C58.2919 56.4216 55.9232 58.7472 53.0106 58.7472C50.0994 58.7477 47.7302 56.4216 47.7302 53.5633Z",
    fill: "#8FB16A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_254",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.694118 0 0 0 0 0.415686 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_254",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentilation);
export default __webpack_public_path__ + "static/media/ventilation.a417282b648e44e3db3b2d98af83a84c.svg";
export { ForwardRef as ReactComponent };